import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';

// @ts-expect-error
import ENV from 'receivable-invoices-js/config/environment';

let { backendUrlsTable, frontendUrlsTable } = getUrlsTable(ENV);

export const { apiBaseURL, landingURL } = backendUrlsTable;

export const { appJsURL } = frontendUrlsTable;

export const apiNamespace = 'v2';
export const paymentLinkNamespace = 'v2';
export const paymentsNamespace = 'v1/payments';
export const receivableInvoicesApiNamespace = 'v5';
export const tykApiNamespace = 'v2';
